<div>
  <div class="additional_services__title">
    <h1 class="font-size-headline3">UDT Additional Services</h1>
    @if (additionalServicesCard.length > 3) {
      <div class="additional_services__buttons">
        <button
          mat-icon-button
          NguCarouselPrev
          [disabled]="disablePrevSlide()"
          (click)="prevSlide()"
          [ngClass]="{ disabled: disablePrevSlide() }"
          type="button"
        >
          <img src="../../../../../assets/svg/chevron_left.svg" alt="left arrow" class="arrow-left" />
        </button>
        <button
          mat-icon-button
          NguCarouselNext
          [disabled]="disableNextSlide()"
          (click)="nextSlide()"
          [ngClass]="{ disabled: disableNextSlide() }"
          type="button"
        >
          <img src="../../../../../assets/svg/chevron_right.svg" alt="right arrow" class="arrow-right" />
        </button>
      </div>
    }
  </div>
  @if (isFetching) {
    <!-- Skeleton Loader Template -->
    <div class="skeleton-container">
      <!-- Skeleton Loader for cards -->
      <div class="skeleton-cards">
        @for (card of [1, 2, 3]; track card) {
          <ngx-skeleton-loader
            [theme]="{ width: '450px', height: '430px', margin: '0 10px', background: 'var(--udt-white)' }"
          ></ngx-skeleton-loader>
        }
      </div>
    </div>
  } @else {
    <div class="additonal_services__cards">
      @if (additionalServicesCard.length === 0) {
        <h4>There are not Additional Services yet</h4>
      } @else {
        <owl-carousel-o [options]="customOptions" class="additional_services__carousel" #owlCarousel>
          @for (slide of additionalServicesCard; track slide.id; let i = $index) {
            <ng-template carouselSlide let-owlItem [id]="slide.id.toString()">
              <additional-service-card
                class="additional_services__carousel--tile"
                [serviceAddon]="slide"
                [cardColor]="i % 2 === 0 ? 'blue' : 'green'"
                (addService)="onAddServiceClick($event)"
                [style]="{ height: '100%', display: 'flex' }"
              ></additional-service-card>
            </ng-template>
          }
        </owl-carousel-o>
        <!-- <ngu-carousel
          #myCarousel
          [inputs]="carouselTile"
          [dataSource]="additionalServicesCard"
          class="additional_services__carousel"
        >
          <ngu-tile class="additional_services__carousel--tile" *nguCarouselDef="let item; let i = index">
            <additional-service-card
              [serviceAddon]="item"
              [cardColor]="i % 2 === 0 ? 'blue' : 'green'"
              (addService)="onAddServiceClick($event)"
              [style]="{ height: 'inherit', display: 'flex' }"
            ></additional-service-card>
          </ngu-tile>
          <ul class="additional_services__carousel--points" NguCarouselPoint>
            @for (p of myCarousel.pointNumbers(); track p; let j = $index) {
              <li [class.active]="j == myCarousel.activePoint()" (click)="myCarousel.moveTo(p)"></li>
            }
          </ul>
        </ngu-carousel> -->
      }
    </div>
  }
</div>
